import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import HeroSection from "../../components/heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";
import { FaEnvelope } from "react-icons/fa";
import "../registerDriverPage/RegisterDriverPage.css";
import Footer from "../../components/footer/Footer";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../../api/apiSystem";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

export default function ConfirmEmailForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const showLoadingAlert = () => {
    Swal.fire({
      title: t("confirmEmail.loading.title"),
      text: t("confirmEmail.loading.text"),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  };

  const showSuccessAlert = () => {
    Swal.fire({
      icon: "success",
      title: t("confirmEmail.success.title"),
      text: t("confirmEmail.success.message"),
      confirmButtonColor: '#fd7e14',
      confirmButtonText: t("confirmEmail.success.confirmButton"),
      timer: 3000,
      timerProgressBar: true,
    }).then(() => {
      navigate("/otp-verification");
    });
  };

  const showErrorAlert = (message) => {
    Swal.fire({
      icon: "error",
      title: t("confirmEmail.error.title"),
      text: message,
      confirmButtonColor: '#dc3545',
      confirmButtonText: t("confirmEmail.error.confirmButton")
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // التحقق من صحة البريد الإلكتروني
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showErrorAlert(t("confirmEmail.error.invalidEmail"));
      return;
    }

    setLoading(true);
    showLoadingAlert();

    try {
      const res = await authAPI.confirmAccount({ email });

      if (res.success) {
        localStorage.setItem("confirm_email", email);
        Swal.close();
        showSuccessAlert();
      } else {
        Swal.close();
        showErrorAlert(res.message || t("confirmEmail.error.confirmationFailed"));
      }
    } catch (err) {
      console.error("Email confirmation error:", err);
      Swal.close();
      showErrorAlert(t("confirmEmail.error.generic"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <HeroSection
        backgroundImage={heroPhoto}
        title={t("confirmEmail.heroSection.title")}
        titleHighlight={t("confirmEmail.heroSection.titleHighlight")}
        showTopbar={false}
        showNavbar={true}
        features={t("confirmEmail.heroSection.features", { returnObjects: true })}
        showQuoteForm={false}
        showCTAButton={false}
        customHeight="100%"
      />

      <div className="dark-bg-primary register-driver-section">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="shadow-lg p-4 border-0 register-driver-card">
                <Card.Body>
                  <h4 className="text-center mb-4 text-dark fw-bold">
                    {t("confirmEmail.title")}
                  </h4>
                  <p className="text-center text-muted mb-4">
                    {t("confirmEmail.description")}
                  </p>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formEmail" className="mb-3">
                      <Form.Label className="fw-semibold">
                        {t("confirmEmail.emailLabel")}
                      </Form.Label>
                      <div className="position-relative">
                        <FaEnvelope className="form-icon" />
                        <Form.Control
                          type="email"
                          placeholder={t("confirmEmail.emailPlaceholder")}
                          className="ps-5"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          disabled={loading}
                        />
                      </div>
                    </Form.Group>

                    <Button
                      type="submit"
                      variant="warning"
                      className="w-100 mt-4 bg-orange-500 text-white fw-semibold py-2"
                      disabled={loading}
                    >
                      {loading ? t("confirmEmail.submitButtonLoading") : t("confirmEmail.submitButton")}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
}